export enum UserRole {
  ADMIN = 'admin',
  SUPER_ADMIN = 'super-admin',
  EMPLOYEE = 'employee',
}
